import { createContext } from "react";

const AddDocumentContext = createContext();

export default AddDocumentContext;